import React from "react"
import styled from "styled-components"
import { Modal } from "@bw/partials"
import useGlobalFlyers from "../../../hooks/useGlobalFlyers"

const FlyersWrapper = styled.button`
  display: flex;
  flex-direction: column;
  font-family: "OneDirection";
  border: none;
  background: none;
  color: black;
  background-color: var(--secondary);
  padding: 5px 10px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  > h4 {
    margin: 0;
  }
  &:hover {
    transform: scale(1.1);
    filter: brightness(110%);
  }
`

const Grid = styled.div`
  background-color: #fff;
  padding: 30px 15px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 20px;

  h3 {
    grid-column: 1 / 3;
    color: var(--text-color);
    margin: 0 0 10px;
  }
`

const Download = styled.a`
  display: flex;
  width: fit-content;
  text-decoration: none;
  margin: 5px 0;
  color: black;
  transition: color 0.2s ease-in-out;

  &:hover {
    color: var(--dark);
  }
`

const Flyers = () => {
  const flyers = useGlobalFlyers()
  const [show, setShow] = React.useState(false)

  
  const handleChange = React.useCallback(() => {
      return setShow(!show)
  }, [show])

  if (!flyers || flyers.length === 0) {
    return null
  }

  return (
    <>
      <FlyersWrapper onClick={() => handleChange()}>Flyers</FlyersWrapper>
      <Modal {...{ show, setShow }}>
        <Grid>
          <h3>Téléchargez le dépliant</h3>
          <div>
            {flyers.slice(0, Math.ceil(flyers.length / 2)).map(flyer => (
              <Download
                key={flyer.locale}
                download
                href={flyer.document.url}
                rel="noreferrer"
                target="_blank"
              >
                {flyer.locale}
              </Download>
            ))}
          </div>
          <div>
            {flyers.slice(Math.ceil(flyers.length / 2)).map(flyer => (
              <Download
                key={flyer.locale}
                download
                href={flyer.document.url}
                rel="noreferrer"
                target="_blank"
              >
                {flyer.locale}
              </Download>
            ))}
          </div>
        </Grid>
      </Modal>
    </>
  )
}

export { Flyers }
